// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"850864e8","488":"0afbb53a"}[chunkId] + ".chunk.js";
};